module.exports = __webpack_public_path__ + "img/pay-date.ad85e856.svg";